export const TranslationsFI = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Onlinetilaus",
        cart: "ostoskori",
        open_24: "24 tunti",
        closed: "Suljettu",
        free: "ILMAINEN",
        something_went_wrong: "Jotain meni pieleen",
        try_again: "kokeile uudestaan",
    },
    constants: {
        calendar: {
            days: {
                monday: "Maanantai",
                tuesday: "Tiistai",
                wednesday: "Keskiviikko",
                thursday: "Torstai",
                friday: "Perjantai",
                saturday: "Lauantai",
                sunday: "Sunnuntai",
            },
        },
        services: {
            pickup: "Nouto",
            delivery: "Kotiinkuljetus",
            dine_in: "Syö paikan päällä",
            table_booking: "Pöytä varaus",
        },
        payment: {
            method: {
                cash: "Käteinen",
                card: "Korttimaksu",
                stripe: "Luottokortti",
                paypal: "PayPal",
                cardconnect: "Luottokortti",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            backend_method: {
                cash: "Käteinen",
                card: "Korttimaksu",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "Cardconnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            status: {
                success: "Menestys",
                pending: "Odottaa",
                error: "virhe",
                refunded: "Palautus",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "poista",
                drop_here: "Siirrä kansiot tähän tai valitse listalta",
                accepts: "Hyväksy {{fileTypes}} kansiot",
                errors: {
                    max_files: "Enintään {{number}} sallittu",
                    max_size: "Max file size of {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Myymälä on suljettu ja tällä hetkällä ei voi lähetä tilauksia.Voit kokeila myöhämmin uudestaan",
            },
            buttons: {
                order: {
                    book_order: "Pöytä varaus / Onlinetilaus",
                    order_online: "Onlinetilaus",
                    book_table: "pöytä varaus",
                    order: "tilaa",
                    book: "Varaa",
                    cart: "Ostoskori",
                    restart: "Käynistä uudestaan",
                    closed: "Myymälä Suljettu",
                    not_accepting: "ei otetaan tilauksia vastaan",
                },
            },
        },
        modals: {
            auth: {
                login: "Kirjaudu",
                register: "Rekisteröinti",
                register_commence: "Jatkaa",
                register_complete: "Tilin avaus",
                register_confirmation_sent: ". Kirjoita se alla jatkaaksesi",
                register_confirmation_resent: "Vahvistus koodi lähetätty uudestaan,tarkista roskapostit tai käynnistä uudelleen",
                register_restart: "Käynnistä Uudelleen",
                register_resend_code: "Lähetä koodi uudestaan",
                login_placeholder: "S.posti",
                password_placeholder: "Salasana",
                confirm_password_placeholder: "salasanan vahvistus",
                confirmation_code_placeholder: "S.posti vahvistus koodi",
                accept_terms: "Hyväksy Ehdot",
                accept_terms_view: "Näytä",
                login_facebook: "Kirjaudu Facebook tunnuksilla",
                login_google: "Kirjaudu google tunnuksilla",
                benefits: "Kirjaudu tai luo tili tallentamaan kaikki tilaukset",
                logged_in: "Olet kirjautunut tilille",
                logged_out: "kirjautunut ulos",
                password_reset: {
                    init_button: "lähetä salasanan palautus s.postille",
                    init_success: "Salasanan palautus linkki lähetätty s.postilla",
                    complete_button: "Salasanan palautus",
                    complete_success: "Salasana nollattu,kirjaudu käyttämällä uuden salasanan",
                    forgot_password_text: "Unohditko salasana? ",
                    forgot_password_link: "Salasanan nollaus",
                    remember_password_text: "Muistatko salasana? ",
                    remember_password_link: "takaisin",
                    invalid_title: "Salasanan nollaus virheellinen",
                    invalid_description: "Tämä salasanan nollauslinkki ei kelpaa, pyydä uusi linkki",
                    invalid_link: "siirry sisäänkirjautumiseen",
                    title: "Salasanan nollaus",
                    description: "Anna uusi salasana tilillesi",
                },
                error_generic: "meni pieleen, ole hyvä ja yritä uudelleen tai ota meihin yhteyttä",
                error_accept_terms: "Ole hyvä ja hyväksy ehdot",
                error_password_length: "Minimum 6 merkkiä salasanalle",
                error_social: "Jotain meni pieleen, ole hyvä ja yritä uudelleen tai ota meihin yhteyttä",
                error_confirmation_code: "vahvistus koodi on väärin",
                error_invalid_code: "väärä vahvistuskoodi",
                error_exists: "Käyttäjä on jo rekisteröity",
                error_invalid_email_pass: "virheellinen s.posti tai salsana",
                error_password_no_match: "Salasana ei täsmää",
                error_user_not_found: "tällä s.postilla ei ole rekisteröity käyttäjä löytyy",
                error_invalid_email: "virheellinen s.posti",
                error_invalid_reset_token: "virheellinen nollauslinkki,pyydä uudestaan",
            },
            booking: {
                form: {
                    name: "Nimi",
                    email: "Sähköposti",
                    phone: "Puhelin numero",
                    number_of_people: "Henkilö määrä",
                    number_of_people_max: "Henkilö määrä ({{max_people}} Max)",
                    number_of_people_min: "Henkilö määrä ({{min_people}} Min)",
                    number_of_people_max_min: "Henkilö määrä (Between {{min_people}} to {{max_people}})",
                    notes: "Erikoispyynnöt",
                    submit: "lähetä varauspyyntö",
                    email_optional: "(valinnainen)",
                    date: "Päivämäärä",
                    duration: "Kesto",
                    seating: "Vapaat ajat",
                    number_of_guests: "Vieraiden määrä",
                    notes_placeholder: "Allergiat, tilaisuus, paikkatoive",
                    reserving: "Varataan...",
                    reserve_table: "Varaa pöytä",
                    please_choose_a_date_and_time: "Valitse päivämäärä ja kellonaika.",
                    invalid_people: "Henkilömäärän on oltava välillä {{min}}–{{max}}.",
                    party_size_max_fallback: "sallittu enimmäismäärä",
                    loading_available_times: "Ladataan vapaita aikoja…",
                    select_a_date_to_see_available_times: "Valitse päivämäärä nähdäksesi vapaat ajat.",
                    no_times_available_for_this_date: "Tälle päivälle ei ole vapaita aikoja. Valitse toinen päivä.",
                    shift: "Vuoro",
                    service_times: "Palveluajat",
                    new_shift: "Uusi vuoro",
                    time: "aika",
                    times: "ajat",
                    unavailable: "Ei saatavilla",
                    available: "Saatavilla",
                    required_name: "Kirjoita nimesi.",
                    required_phone: "Kirjoita puhelinnumerosi.",
                    required_email: "Kirjoita sähköpostiosoitteesi.",
                    invalid_email: "Kirjoita kelvollinen sähköpostiosoite.",
                    required_terms: "Hyväksy ehdot ennen varaamista.",
                    missing_custom_fields: "Vastaa kaikkiin pakollisiin kysymyksiin.",
                    reservation_is_unavailable: "Varaus ei ole saatavilla.",
                    please_contact_the_restaurant_directly: "Ota yhteyttä ravintolaan suoraan.",
                    almost_done: "Melkein valmis",
                    your_details: "Tietosi",
                    tell_us_who_s_coming: "Kerro kuka on tulossa, jotta voimme vahvistaa varauksesi.",
                    book_your_table: "Varaa pöytäsi",
                    choose_a_time_that_works_for_you: "Valitse sinulle sopiva aika.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Lähetä varauspyyntösi, niin ravintola hoitaa loput.",
                    select_date: "Valitse päivämäärä",
                    standard: "Vakio",
                    minutes: "minuuttia",
                    next: "Seuraava →",
                    back: "← Takaisin",
                    accept_terms: "Hyväksyn käyttöehdot.",
                    info_1: "Lähetämme s.posti viestin kun varauspyyntösi käsitelty",
                },
                errors: {
                    not_found: "Varaus ei löyty.se on ehkä poistettu",
                    generic: "Jotain meni pieleen, lataa sivu uudestaan tai ota meihin yhteyttä",
                    something_went_wrong: "Jotain meni pieleen",
                    accept_terms: "Ole hyvä ja hyväksy ehdot",
                    required_phone: "Puhelin numero",
                    required_email: "Sähköposti osoite",
                    required_name: "Nimi",
                    invalid_email: "Ole hyvä ja kirjoita toimiva sähköposti osoite",
                    invalid_phone: "Ole hyvä ja kirjoita toimiva puhelin numero",
                    invalid_people: "virheellinen henkilö määrä",
                    booking_capacity_threshold: "Olemme täynnä tähän aikaan. Kokeile toista aikaa.",
                    slot_unavailable: "Olemme täynnä tälle henkilömäärälle. Kokeile toista aikaa.",
                    booking_date_paused: "Varaukset on keskeytetty tälle päivälle. Valitse toinen päivä.",
                    invalid_table_assignment: "Nuo pöydät eivät mahdu seurueellenne. Valitse toinen aika.",
                    exceeded_order_limit: "Liian monta varauspyyntöä. Yritä myöhemmin uudelleen.",
                    validation_failed_recaptcha_v3: "Epätavallista liikennettä havaittu. Käytätkö VPN:ää? Suorita yllä oleva tarkistus ja yritä uudelleen.",
                    validation_failed_recaptcha_v2: "Varausta ei voitu aloittaa. Yritä uudelleen tai käytä toista tapaa. Jos käytät VPN:ää, kokeile ensin poistaa se käytöstä.",
                    booking_already_exists: "Tämä varaus on jo lähetetty. Tarkista sähköpostisi tai avaa varauslinkkisi.",
                    invalid_party_size: "Valitse kelvollinen henkilömäärä.",
                    invalid_request: "Virheellinen pyyntö. Päivitä sivu ja yritä uudelleen.",
                    table_booking_unavailable: "Pöytävaraus ei ole saatavilla.",
                },
            },
            cart: {
                title: "Ostoskori",
                proceed_to_checkout: "jatka maksamaan",
                edit_dish: "Lisää",
                remove_dish: "Poista",
                no_items_1: "Ostoskori on tyhjä",
                no_items_2: "Lisää tuote jatkaaksesi",
                free_delivery_notice: "Ilmainen toimitus kum tilaus yli {{value, currency}}",
                errors: {
                    min_order_promo: "vaaditaan minimum tilaus arvo {{value, currency}} ennen tämän tarjouksen asettamista",
                    min_order_delivery: "Minimum tilaus arvo {{value, currency}} toimitus varten",
                },
                promo: {
                    heading: "Alennus koodi",
                    placeholder: "anna alennus koodi",
                    add: "Lisää koodi",
                    title: "Alennus {{name}} lisätty ostoskoriin",
                    fixed_discount: "{{value, currency}} Off",
                    percent_discount: "{{value}}% Off",
                    added_to_cart: "Alennus lisätty ostoskoriin",
                    errors: {
                        not_found: "Alennus koodi ei löytyy",
                        disabled: "Alennus koodi poistettu",
                        not_available: "Alennus ei ole tällä hetkellä saatavilla ",
                        logged_in_only: "sinun on oltava kirjautuneena sisään käyttääksesi alennus koodin",
                        already_used: "Alennus koodi on käytetty",
                        invalid: "This Alennus ei ole käytettävissä",
                        invalid_service: "Alennus koodi ei ole käytettävissä valitsemasi palvelulla",
                        later_only: "voimassa vain ennakkotilauksissa",
                        now_only: "Voimassa vain heti erääntyviin tilauksiin , ei ennakkotilauksiin",
                        generic: "Oops... Jotain meni pieleen ja kirjautunut sisään",
                        dishes_required_multi: "Tämä tarjous otetaan käyttöön vain, kun tietyt ruokia lisätään ostoskoriin",
                        dishes_required_single: "tämä otetaan käyttöön  '{{Dish}}'",
                    },
                },
                tip: {
                    title: "Tilaus Tippi",
                    placeholder: "Lisää tippi",
                },
            },
            checkout: {
                title: "Maksamaan",
                subtitle: "vahvista tilaustiedot",
                details: {
                    service: "Palvelu",
                    due: "Maksettava",
                    due_now_asap: "Heti",
                    address: "Toimitus osoite",
                    total: "Yhteensä",
                    table: "Pöytä",
                    store_location: "ravintolan osoite",
                },
                customer: {
                    title: "Asiakas",
                    subtitle: "Kirjaudu sisään tallentaaksesi tilauksia",
                    button: "Kirjaudu",
                    name: "Nimi",
                    email: "S.posti",
                    phone: "Puh.no",
                    phone_important: "Puh.no (Tärkeä)",
                    notes: "Muistinpanot",
                    delivery_notes: "Toimitusohjeet",
                    optional: "Valinnainen"
                },
                payment: {
                    title: "Maksutavat",
                },
                accept_terms: "Hyväksy ehdot",
                accept_terms_view: "Näytä",
                processing_order: "tilauksen käsittely",
                warning: {
                    different_payment_currency: "Ravintalon hinnasto {{Store_currency}} mutta maksutapa {{payment_currency}}",
                    closing_soon: "kohta suljetaan,pitä lähetä tilaukset {{value}} minuutin sisällä",
                    closed: "Anteeksi palvelu on tällä hetkellä suljettu tilauset eibotettu vastaan ",
                    expired: "Emme voi enää käsitellä tilauksasi valittuna aikana. Ole hyvä ja valitse toinen aika",
                },
                errors: {
                    stripe_generic: "Luottokortti virhe, yritä uudestaan tai vaihta maksutapa",
                    stripe_loading_fail: "maksutapa lataus virhe, ole hyvä ja yritä uudestaan",
                    something_went_wrong: "Jotain meni pieleen",
                    paypal_generic: "jotain meni pieleen PayPal kanssa, yritä uudestaan tai vaihta maksutapa",
                    payment_fail: "Maksu ei onnistunut, yritä uudestaan tai valitse toinen maksutapa",
                    payment_cancelled: "Maksu peruuttu, ole hyvä yritä uudestaan or valitse toinen maksutapa",
                    payment_error: "virhe online maksun käsittelyssä,yritä uudestaan tai valitse toinen maksutapa",
                    payment_declined: "maksutapasi hylättiin",
                    card_declined: "Korttiasi ei hyväksytty ja maksu ei onnistunut",
                    promo_max_uses_exceeded: "Tämä tarjouskoodi on saavuttanut käyttörajansa eikä ole enää saatavilla.",
                    store_closed: "Ravintola on suljettu ei tällä hetkellä otetaan tilauksia vastaan",
                    accept_terms: "ole hyvä ja hyväksy ehdot",
                    required_payment: "Valitse maksutapa",
                    required_phone: "Puhelin numero",
                    required_email: "Sähköposti osoite",
                    required_name: "Nimi",
                    invalid_email: "Kirjoita tomiva sähköposti osoite",
                    invalid_phone: "Kirjoita toimiva puhelin numero",
                    invalid_cc_number: "Luottokortti tietosi virheellinen",
                    retry_cc_number: "jotain meni pieleen, kirjoita kortin numerot ja kokeile uudestaan ",
                    closed: "Ravintola on suljettu/suljetaan ei otetaan tilauksia vastaan",
                    promo_login_required: "on oltava kirjautuneena sisään käyttääksesi tätä alennusta",
                    promo_used: "Olet jo käyttänyt tätä alennusta",
                },
                button: {
                    continue: "Maksamaan",
                    place_order: "Lähetä tilaus",
                },
            },
            customer: {
                age_v: {
                    title: "Ikä vahvistus",
                    required_for_items: "Vaditaan tiettyjen tuotteiden tilamiseen",
                    min_age: "Minimum ikä: {{ikä}} vuotta",
                    est_time: "Arvioitu varmennusaika: {{aika}} tunti",
                    upload_description: "Lataa henkilötiedot vahvistamiseen. lähetämme sinulle s.posti kun vahvistettu. voit lähetä 2 kuva joka on enintään kooltaan 2 Mbte",
                    pending_description_1: "kiitos henkilötietosi lähettämisesta. Ilmoitamme rekisteröinnistä s.postilla.",
                    pending_description_2: "lataa sivun uudestaan päivittämään varmennustilaan.. Arvioitu varmennusaika {{aika}} tunti",
                    approved_description: "Tilisi on valmis nyt voit tilata",
                    rejected_description: "Tunnuksesi on hylätty. jos haluat yritä uudestaan lataa henkilökortti uudestaan",
                    upload: "Lataa",
                    reupload: "Lataa uudestaan asiakirja",
                    go_back: "Takaisiin",
                    view_document: "Näytä asiakirja {{number}}",
                    status: {
                        unverified: " Ei ole vahvistettu",
                        pending: "Odetetaan hyväksymistä",
                        approved: "Hyväksytty",
                        rejected: "Hylätty",
                    },
                },
                headings: {
                    sessions: "istuntoa",
                    orders: "Tilaus",
                    spend: "Viettää",
                    order_history: "tilaus historia",
                    loyalty_points: "Uskollisuuspisteet",
                },
            },
            custom_payment: {
                title: "{{name}} Maksulomake",
                description: "Sait meidän maksulomakkeen.ole hyvä ja täyttää tarvittavat tiedot. jos tiedot ei ole täytetty, tietosi tallennetaan mutta sinua ei veloiteta.",
                disabled: "Tätä online-maksusivua ei ole määritetty oikein. Ota yhteyttä sivuston omistajaan korjataksesi ongelman.",
                success: "Maksusi suoritettiin onnistuneesti ja tietosi on tallennettu. Kiitos",
                back: "Takaisin kotiin",
                fields: {
                    name: "Nimi",
                    email: "Sähköpoti",
                    reference: "viitenumero",
                    amount: "määrä ($)",
                    name_on_card: "Kortin omistajan nimi",
                    submit: "Lähetä maksu",
                },
                warning: {
                    currency: "Huomaa: Maksun summa euroina {{actual}}, ei ole {{default}}",
                },
                errors: {
                    generic: "Jokin meni pieleen, yritä uudelleen tai ota meihin yhteyttä",
                    stripe_generic: "Luottokorttivirhe, päivitä sivu ja yritä uudelleen",
                    payment_fail: "Maksu epäonnistui, yritä uudelleen tai valitse toinen maksutapa",
                    payment_cancelled: "Maksu peruutettu, yritä uudelleen tai valitse toinen maksutapa",
                    payment_error: "Virhe verkkomaksun käsittelyssä, yritä uudelleen tai valitse toinen maksutapa",
                    payment_declined: "Maksutapasi hylättiin",
                    card_declined: "Korttisi hylättiin, ja maksua ei voitu käsitellä",
                    promo_max_uses_exceeded: "Tämä tarjouskoodi on saavuttanut käyttörajansa eikä ole enää saatavilla.",
                },
            },
            dish: {
                add: "Lisää ostoskoriin",
                edit: "Päivitä tuote",
                notes: "Erityisohjeet...",
                ingredients: {
                    title: "ainekset",
                    uncheck_remove: "Poista valinta valitsemalla valinta",
                },
                ingredients_title: "ainekset",
                combo: {
                    choose_dish: "Valitse Ruoka-Annos",
                },
                option_sets: {
                    conditions: {
                        select_one: "valitse (pakkollinen)",
                        select_one_optional: "Valitse (valinnainen)",
                        select_between: "Valitse välillä {{min}} - {{max}} (pakollinen)",
                        select_at_least: "Valitse vähintään {{qty}} (Pakollinen)",
                        select_up_to: "Valitse max. {{qty}} (valinnainen)",
                        select_multiple: "Valitse useita (valinnainen)",
                        free_amount: "Ensin{{qty}} Ilmainen / {{Valittu}} Valittu",
                    },
                },
                error: "Korjaa kaikki punaisella merkityt vaihtoehdot",
                added_to_cart: "Tuote lisätty ostoskoriin",
            },
            map: {
                zone_fee: "Kuljetusmaksu",
                view_in_google: "Näytä Google Mapsissa",
            },
            portal_go_back: {
                title: "Palaa takaisin ravintolahakuun?",
                description: "Kaikki ostoskorisi tuotteet poistuu",
                cancel: "Peruuttaa",
                proceed: "Takaisiin",
            },
            order: {
                config: {
                    services: {
                        title: "Valitse palvelu",
                        table_booking: "Pöytä varaus",
                    },
                    address_custom: {
                        input_placeholder: "Kirjoita osoitteesi",
                    },
                    address: {
                        input_placeholder: "Löydä toimitusosoitteesi",
                        extras_placeholder: "Valinnainen: yksikön numero, rakennuksen nimi jne...",
                        search_placeholder: "Etsi osoitteesi",
                        not_found: "Toimitusosoitetta ei löytynyt tai kelpaa, yritä uudelleen",
                        not_delivering: "Emme tällä hetkellä toimita tähän osoitteeseen",
                        not_in_range: "Osoitteesi ei ole meidän toimitusalueella",
                        not_in_zone: "Osoitteesi ei ole aktiivisen toimitusalueen sisällä",
                    },
                    datetime: {
                        title: "Milloin haluaisit tilauksesi",
                        due_now: "Nyt",
                        due_later: "Myöhämmin",
                        service_not_available: "Valitettavasti emme tällä hetkellä hyväksy tilauksia kohteelle {{service}}",
                        currently_closed: "{{service}} tällä hetkellä suljettu, mutta voit tilata myöhemmi",
                        due_unavailable: "Ei saatavilla",
                        due_closed: "Suljettu",
                        select_date: "Valitse päivä",
                        select_time: "Valitse aika",
                        select_order_date: "Valitse tilauksesi päivämäärä",
                        select_order_time: "Valitse tilausaika",
                        select_booking_date: "Valitse varauspäivämäärä",
                        select_booking_time: "Valitse varausaika",
                        no_times_available: "Ei aikoja, joista valita",
                        date_today: "(Tänään)",
                        date_closed: "(Suljettu)",
                        date_bookings_paused: "(Varaukset keskeytetty)",
                        time_slot_closed: "Suljettu",
                    },
                    number_of_people: {
                        placeholder: "Henkilöiden määrä",
                    },
                    table: {
                        select: "Valitse pöytä",
                        select_popup_title: "Valitse pöytä",
                        password: "Päytä salasana",
                        password_warning: "Kirjoita taulukon salasana jatkaaksesi",
                    },
                    warning: {
                        closed: "Valitettavasti olemme tällä hetkellä suljettu / emme hyväksy tilauksia",
                        not_available: "Valitettavasti emme tällä hetkellä hyväksy tilauksia",
                    },
                    start_button: "Aloita tilaus",
                },
                history: {
                    invalid: "Ei voida tilata uudelleen, koska joitain tilatuista tuotteista on muokattu tai niitä ei enää ole saatavana",
                },
                reorder: {
                    title: "Nopea tilaus",
                    description: "Tilaa tuotteet aiemmilta tilauksilta helpost",
                },
            },
            receipt: {
                errors: {
                    not_found: "Tilausta ei löytynyt, päivitä sivu ja yritä uudelleen",
                    booking_not_found: "Varausta ei ole olemassa. Se on saatettu poistaa",
                    generic: "Jokin meni pieleen, päivitä sivu tai ota meihin yhteyttä",
                },
                connection: {
                    connected: "Reaaliaikaiset päivitykset",
                    connecting: "Reaaliaikaiset päivitykset muodostavat yhteyden",
                    disconnected: "Reaaliaikaiset päivitykset katkaistu",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Varoitus",
                    title: "Kirjautua ulos",
                    body: "Uloskirjautuminen poistaa kaikki ostoskoriin lisätyt tuotteet",
                    cancel: "Peruuttaa",
                    proceed: "Proceed",
                },
                order_restart: {
                    warning: "Varoitus",
                    title: "Muuta tilaustietoja",
                    body: "Tilaustietojen muuttaminen poistaa tuotteet ostoskoristasi, koska tiettyjä ruokia ei ehkä ole saatavana",
                    cancel: "Peruuttaa",
                    proceed: "Proceed",
                },
                order_expired: {
                    subtitle: "Tärkeä",
                    title: "Tilaus muuttui erääntyväksi heti",
                    description: "Tilauksellesi valittu aika ei ole nyt kaukana. Sellaisena tilauksesi on muutettu heti / mahdollisimman pian",
                    button: "Ok",
                },
                order_expiring: {
                    subtitle: "Tärkeä",
                    title: "Tilauksen määräaika päättyy pian",
                    description: "Tilauksesi on tehtävä ennen {{time, timeFromTimestamp}} muuten se ei ole enää voimassa",
                    button: "Ok",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Vieras",
                login: "Kirjaudu",
                login_signup: "Kirjaudu / Rekisteröidy",
                logout: "Kirjaudu ulos",
            },
            menus: {
                info: {
                    no_menus: "Tällä hetkellä valikoita ei ole saatavana",
                    restrictions: "Valikkorajoitukset",
                    not_available: "Valikko ei tällä hetkellä käytettävissä",
                    unavailable: {
                        times: "Valikkoa ei ole saatavana, tilauksesi vaatimukset eivät vastaa alla olevaa",
                        services: "Valikkoa ei ole saatavana, tilauksesi vaatimukset eivät vastaa alla olevaa",
                        hours: "Valikkoa ei ole saatavana, tilaustunnisi eivät ole käytettävissä tämän valikoiden käytettävissä olevien tuntien sisällä",
                        pre_order: "Valikkoa ei ole saatavana, tilauksesi ei vastaa ennakkotilauksen vaatimuksia",
                        age: "Valikkoa ei ole saatavana, sinun on oltava kirjautuneena sisään ikävahvistetulla tilillä, jotta tilaat tästä valikosta",
                    },
                    services: {
                        title: "Tilausvaatimukset",
                        pickup: "Noudot",
                        delivery: "Kotiinkuljetukset",
                        dine_in: "Syö paikan päällä",
                    },
                    times: {
                        now: "Ei ennakkotilauksia",
                        later: "Vain ennakkotilaukset",
                    },
                    hours: {
                        title: "Käytettävissä aukioloajat",
                    },
                    preorder: {
                        title: "Ennakkotilauksen vaatimukset",
                        days_in_advance: "täytyy tilata{{days}} päivää etukäteen",
                        cutoff_time: "Viimeisen päivän sulkeutumisaika klo {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Ikä rajoitettu",
                        approved: "Tilisi on vahvistettu ja voit tilata tästä valikosta",
                        rejected: "Vaatii ikävakuutuksen tilaamiseksi. Luo tili ja lähetä tunnuksesi",
                    },
                },
            },
            info: {
                location: {
                    title: "Sijainti",
                    view_map: "Näytä kartta",
                    phone: "Puhelin",
                },
                hours: {
                    title: "Aukioloajat",
                    title_special: "Erikois aukioloajat",
                },
                services: {
                    title: "Palvelut",
                    notes: "Muistinpanot",
                    delivery: {
                        ranges: "Kuljetusalue",
                        zones: "Kuljetusalueet",
                        view_zones: "Näytä alueet kartalla",
                        fee: "Kuljetusmaksu",
                        fee_short: 'Maksu',
                        fee_varies: "Vaihtelee, näkyy ostoskorissa",
                        min_order: "Mimitilaus",
                        min_order_short: 'Min. til.',
                        no_min_order: "Ei minimitilaus",
                        free_amount: "Ilmainen toimitusmäärä",
                    },
                },
            },
            contact: {
                title: "Ota yhteyttä",
                name: "Nimi",
                email: "S.posti",
                phone: "Puhelin numero",
                message: "Kirjoita viesti...",
                send: "Lähetä viesti",
                success: "Viestisi on lähetetty onnistuneesti",
                error: "Jokin meni pieleen, yritä uudelleen tai myöhemmin",
            },
            footer: {
                powered_by: "Powered By",
                terms_and_conditions: "Terms & Conditions",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Varauskuitti',
            details: {
                datetime: 'Varaus',
                number_of_people: 'Henkilö määrä',
                placed: 'Sijoitettu',
                updated: 'Viimeksi päivitetty',
                notes: 'Muistinpanot',
                name: 'Nimi',
                email: 'S.posti',
                phone: 'Puhelin numero',
                store_address: 'Ravintolan osoite',
            },
            status_update: {
                title: 'Varaus {{number}} päivitetty',
                body: 'Varaustilaasi on päivitetty {{status}}',
            },
            email_status_update_customer: {
                subject: 'Varaus #{{number}} – {{subjectLabel}}',
                body: 'Varauksesi #{{number}} ravintolassa {{store}} on nyt {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Tilaus #{{number}} – {{subjectLabel}}',
        header: 'Päivitetty valmistumisaika',
        title: 'Päivitetty valmistumisaika',
        order_number: 'Tilausnumero: {{number}}',
        description: 'Tilauksesi on nyt valmis klo {{time}}.',
        order_time_updated_to: 'Tilauksesi aika on päivitetty.',
        powered_by: 'Powered By {{name}}',
        button_text: 'Seuraa järjestystä',
        subject_label: 'Päivitetty valmistumisaika',
        subject_label_delivery: 'Päivitetty toimitusaika',
        body_ready: 'Tilauksesi on nyt valmis klo {{time}}.',
        body_delivery: 'Tilauksesi toimitetaan nyt klo {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Arvioitu valmistusaika',
            est_driver_pickup_time: 'Arvioitu Kuljettajan noutoaika',
            est_delivery_time: 'Arvioitu toimitusaika',
            tab_details: 'Yksityiskohdat',
            tab_dishes: 'Annokset',
            details: {
                status: 'Tila',
                placed: 'sijoitettu',
                due: 'maksettava',
                due_asap: 'Heti / mahdollisimman pian',
                last_updated: 'Viimeksi päivitetty',
                total: 'Yhteensä',
                type: 'Tyypi',
                table: 'Pöytä',
                number_of_people: 'Henkilö määrä',
                payment_method: 'Maksutapa',
                payment_status: 'Maksun tilanne',
                payment_currency: 'Maksun valuutta',
                notes: 'Muistinpanot',
                name: 'Nimi',
                email: 'S.posti',
                phone: 'Puhelin numerot',
                distance: 'Etäisyys',
                driving_time: 'Ajoaika',
                delivery_zone: 'alue',
                delivery_address: 'Toimitus osoite',
                delivery_tracking: 'Toimituksen seuranta',
                delivery_tracking_link: 'Reaaliaikainen seurantalinkki',
                tookan_status: 'Tookan tila',
                tookan_status_failed_book: 'Toimituksen varaaminen epäonnistui',
                tookan_status_failed_update: 'Varauksen päivitys epäonnistui',
                tookan_status_success: 'Varattu toimitukseen',
                store_address: 'Ravintolan osoite',
            },
            dishes: {
                headings: {
                    quantity: 'määrä',
                    item: 'Tuote',
                    price: 'Hinta',
                },
                notes: 'Muistinpanot',
                remove_ingredients: 'Poista ainesosat',
            },
            status_update: {
                title: 'Tilaus {{number}} Päivitety',
                body: 'Tilauksesi tila on päivitetty {{status}}',
            },
            wait_time_update: {
                title: 'Tilaus {{number}} Päivitety',
                body: 'Tilauksesi määräaika on päivitetty',
            },
            delivery_update: {
                title: 'Tilaus {{number}} päivitetty',
                body: 'Tilauksesi on varattu toimitettavaksi. Katso reaaliaikainen seurantalinkki',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Seuraa järjestystä",
                track_delivery_button_text: "Seuraa toimitusta",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Seuraa järjestystä",
                track_delivery_button_text: "Seuraa toimitusta",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) sis. hinta",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Kuljetusmaksu",
            promo: "Alennus: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Alennus: {{name}} ({{percent}}%)",
            promo_fixed: "Alennus: {{name}}",
            promo_none: "Alennus: {{name}}",
            cart: "Ostoskori",
            tip: "Tilaus tip",
            total: "yhteensä",
        },
        status: {
            unconfirmed: "Vahvistamaton",
            awaiting_payment: "Odotetaan maksua",
            confirmed: "Vahvistettu",
            ready: "Valmis",
            on_route: "Matkalla",
            complete: "Valmis",
            cancelled: "peruttu",
            seated: "Pöydässä",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Ei saatavilla",
                },
            },
            dish: {
                no_stock: "Ei saatavilla",
                not_available: "ei saatavilla",
            },
        },
    },
};
//# sourceMappingURL=fi.js.map